import CourseGradeTable from './CourseGradeTable';

export default CourseGradeTable;
